import { render, staticRenderFns } from "./lwf.vue?vue&type=template&id=17bb8e61&"
import script from "./lwf.vue?vue&type=script&lang=js&"
export * from "./lwf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports